import React from "react";
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

interface RoundChartProps {
  data?: any[];
}

const RoundChart: React.FC<RoundChartProps> = ({ data = [] }) => {
  const labels = data?.map(
    (item: any) => item?.checklistName
  );

  const series = data?.map(
    (item: any) => Number(item?.checkListFailedPercentage ?? 0)
  );

  const colors = [
    "#C96545",
    "#F4BF71",
    "#6FA6BE",
    "#8FA985",
    "#A48AD0",
    "#5C5249",
    "#E76F51",
    "#2A9D8F",
    "#E9C46A",
    "#264653",
    "#F28482",
    "#84A59D",
    "#577590",
    "#BC6C25",
    "#9C6644",
  ];

  const chartData = data.map((item: any, index: number) => ({
    name: item?.checklistName,
    value: Number(item?.checkListFailedPercentage ?? 0),
    color: colors[index % colors.length],
  }));

  /**
   * Custom center label
   */
  const CenterLabel = () => {
    return (
      <>
        {/* Total */}
        <text
          x="50%"
          y="45%"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#000000"
          fontSize={15}
          fontWeight={400}
        >
          Total
        </text>

        {/* Count */}
        <text
          x="50%"
          y="58%"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#000000"
          fontSize={36}
          fontWeight={700}
        >
          {series.length}
        </text>
      </>
    );
  };
  /**
   * Custom tooltip
   */
  const CustomTooltip = ({
    active,
    payload,
  }: any) => {
    if (!active || !payload?.length) {
      return null;
    }

    const item = payload[0];

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #ddd5c9",
          borderRadius: 6,
          padding: "8px 12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: "#2D241D",
            marginBottom: 3,
          }}
        >
          {item.name}
        </div>

        <div
          style={{
            fontSize: 13,
            color: "#555",
          }}
        >
          {item.value}%
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        width: "100%",
        padding: 20,
        borderRadius: 12,
      }}
    >
      {/* Donut Chart */}
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius="72%"
            outerRadius="92%"
            paddingAngle={0}
            startAngle={90}
            endAngle={-270}
            stroke="#fff"
            strokeWidth={0}
            isAnimationActive={false}
            label={false}
          >
            {chartData.map(
              (entry: any, index: number) => (
                <Cell
                  key={`cell-${index}`}
                  fill={entry.color}
                />
              )
            )}
          </Pie>
          <CenterLabel />

          <Tooltip
            content={<CustomTooltip />}
            cursor={false}
          />

          {/* Center content */}
          {/* <CenterLabel
                        cx={50}
                        cy={50}
                    /> */}
        </PieChart>
      </ResponsiveContainer>

      {/* Custom Legend */}
      <div style={{ marginTop: 45 }}>
        {labels.map(
          (item: string, index: number) => (
            <div
              key={`${item}-${index}`}
              style={{
                display: "flex",
                justifyContent:
                  "space-between",
                alignItems: "center",
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  minWidth: 0,
                }}
              >
                <span
                  style={{
                    width: 10,
                    height: 10,
                    minWidth: 10,
                    borderRadius: "50%",
                    background:
                      colors[
                      index %
                      colors.length
                      ],
                    display:
                      "inline-block",
                  }}
                />

                <span
                  style={{
                    fontSize: 15,
                    color: "#2D241D",
                    overflow: "hidden",
                    textOverflow:
                      "ellipsis",
                    whiteSpace:
                      "nowrap",
                  }}
                >
                  {item}
                </span>
              </div>

              <span
                style={{
                  fontWeight: 600,
                  color: "#2D241D",
                  marginLeft: 10,
                }}
              >
                {series[index]}%
              </span>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default RoundChart;